import { GetStaticProps, NextPage } from 'next'
import Link from 'next/link'
import { BlogHeader } from 'src/components/BlogHeader/BlogHeader'
import { Footer } from 'src/components/Footer/Footer'
import { Breadcrumb } from 'src/components/global/Breadcrumb'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { THEME } from 'src/config/config'
import { apolloSdk } from 'src/graphql/apolloSdk'
import { IBlogTaxonomy } from 'src/graphql/generated/hooks'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'
import { removeTags } from 'src/utils/removeTags'

type Props = {
  blogTaxonomys: IBlogTaxonomy[]
}

const Blogs: NextPage<Props> = ({ blogTaxonomys }: Props) => {
  const title = 'Editorials'
  const description = 'Editorials'
  const meta = <Meta title={title} description={description} url="/blogs/" />
  return (
    <Main meta={meta}>
      <MainContainer id="mainContainer" className="bg-clouds">
        <div className="flex flex-col">
          <Breadcrumb subject="Editorials" />
          <BlogHeader title="Editorials" />
        </div>
        <div className="mb-auto mt-[10px]">
          <div className="w-full items-center justify-between md:mb-0 mb-[30px]">
            <div className="flex flex-col !max-w-[1100px] w-full py-2 px-5 sm:px-0 m-auto">
              <div className="grid md:grid-flow-row grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-[30px]">
                {blogTaxonomys.map((item, index) => {
                  return (
                    <Link
                      key={index}
                      href={`/blogs/${item?.slug}/`}
                      className="bg-white h-[232px] rounded-[5px] px-[27px] pt-[30px] cursor-pointer"
                    >
                      <p className="font-secondary font-bold text-[18px] leading-[27px] text-textdark h-[55px] overflow-hidden">
                        {item?.name}
                      </p>
                      <p className="line-clamp-4 font-primary font-regular text-[15px] leading-[28px] text-darkgray h-[120px]">
                        {removeTags(item?.description || '')}
                      </p>
                    </Link>
                  )
                })}
              </div>
            </div>
          </div>
        </div>

        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </MainContainer>
    </Main>
  )
}

export default Blogs

export const getStaticProps: GetStaticProps<any> = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }
  try {
    const { blogTaxonomys } = await apolloSdk.blogTaxonomies()

    return {
      props: {
        blogTaxonomys: blogTaxonomys || [],
      },
      revalidate: 60,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error occurred in getStaticProps of Blog Index:', error)
    // Graceful fallback in case of an upstream error
    return {
      notFound: true,
      revalidate: 5, // Reattempt fetching during the next static regeneration
    }
  }
}
